<script>
    import axios from 'axios';
    import Button from "primevue/button";

    export default {
        data() {
            return {
                model: {
                    result: false,
                    tariff: null,
                    payedDate: null,
                    description: null,
                    price: 0
                }
            }
        },
        methods: {
            getData(){
                let self = this;
                axios({
                    method: 'get',
                    url: this.getApiUrl + "check_subscription",
                    withCredentials: true
                })
                    .then(function (response) {
                        self.model = response.data;
                    })
                    .catch(function (error) {
                        //console.log(error);
                    });
            },


            closeSubscription(){
                let self = this;
                axios({
                    method: 'post',
                    url: this.getApiUrl  + "close_subscription",
                    withCredentials: true
                })
                    .then(function (response) {

                        self.model.result = false;
                        self.$snotify.info(response.data.message, {
                            timeout: 5000,
                            showProgressBar: false,
                        });

                    })
                    .catch(function (error) {
                        self.$snotify.error(error.response.data.message, {
                            timeout: 5000,
                            showProgressBar: false,
                        });
                    });
            },

        },
        computed: {
            getApiUrl(){
                return this.$config.API_URL + "/panel/";
            },
        },
        mounted () {
            this.getData();
        },
        components: {
            Button,
        }
    }
</script>

<template>
    <div class="flex flex-column border-round p-3 bg-blue-50 subscription_pay__container">
        <h6 class="mb-3">{{ $t('lang.subscription.enabled_msg') }}</h6>
        <span class="text-sm label" v-html="$t('lang.subscription.payed_date', [model.payedDate])" />
        <span class="text-sm label" v-html="$t('lang.subscription.price', [model.price.formatMoney(0, ' ', ' ')])" />
        <span class="text-sm label" v-html="$t('lang.subscription.description', [model.description])" />
        <div>
            <Button
                :label="$t('lang.subscription.cancel')"
                @click="closeSubscription"
                size="small"
                severity="secondary"
                class="w-full sm:w-auto"
                outlined
            />
        </div>
    </div>
</template>

<style scoped>
.subscription_pay__container .label {
    margin-bottom: 0.625rem;
}
</style>
